export default "__VITE_ASSET__yHhHstox__"